import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import "./scss/index.scss";
import * as React from "react";
import { components } from "react-select";
import { SelectField, TextField } from "..";
import { getValueOrEmpty } from "../../core/utils";

var PriceRangeFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(PriceRangeFilter, _React$Component);

  function PriceRangeFilter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PriceRangeFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PriceRangeFilter)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.filterRef = React.createRef(), _this.state = {
      active: false
    }, _this.handleClick = function (event) {
      _this.setState({
        active: true
      });

      event.stopPropagation();
    }, _this.handleClickAway = function (event) {
      if (_this.state.active && !_this.filterRef.current.contains(event.target)) {
        _this.setState({
          active: false
        });
      }
    }, _assertThisInitialized(_this)));
  }

  _createClass(PriceRangeFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickAway);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickAway);
    }
  }, {
    key: "createLabel",
    value: function createLabel() {
      var _this$props = this.props,
          from = _this$props.from,
          to = _this$props.to;

      if (!!from && !!to) {
        return "".concat(from, " - ").concat(to);
      }

      if (from) {
        return "from ".concat(from);
      }

      if (to) {
        return "to ".concat(to);
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var Control = function Control(props) {
        return React.createElement(components.Control, _extends({}, props, {
          isFocused: _this2.state.active
        }));
      };

      var _this$props2 = this.props,
          from = _this$props2.from,
          _onChange = _this$props2.onChange,
          to = _this$props2.to;
      return React.createElement("div", {
        className: "price-filter",
        ref: this.filterRef,
        onClick: this.handleClick
      }, React.createElement(SelectField, {
        placeholder: "Price range",
        menuIsOpen: false,
        components: {
          Control: Control
        },
        value: this.createLabel() ? {
          label: this.createLabel(),
          value: ""
        } : undefined
      }), React.createElement("div", {
        className: "price-filter__dropdown".concat(this.state.active ? " price-filter__dropdown--visible" : "")
      }, React.createElement(TextField, {
        type: "number",
        placeholder: "From",
        onChange: function onChange(event) {
          return _onChange("priceGte", event.target.value);
        },
        value: getValueOrEmpty(from)
      }), React.createElement(TextField, {
        type: "number",
        placeholder: "To",
        onChange: function onChange(event) {
          return _onChange("priceLte", event.target.value);
        },
        value: getValueOrEmpty(to)
      })));
    }
  }]);

  return PriceRangeFilter;
}(React.Component);

export default PriceRangeFilter;